"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ItemList_1 = __importDefault(require("./ItemList"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PostSort = function (_a) {
    var handleSortChange = _a.handleSortChange, close = _a.close, selected = _a.selected;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.post_sort },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.title }, t('SORT.sort_by')),
            react_1.default.createElement("i", { className: classnames_1.default('cm-icon', 'icon-close', styles_module_scss_1.default.close), onClick: function () { return close(); } })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.post_sort_items },
            react_1.default.createElement(ItemList_1.default, { handleSortChange: handleSortChange, selected: selected, handleClose: close }))));
};
exports.default = PostSort;
